export default "__VITE_ASSET__DEUMe4Pq__"